import { render, staticRenderFns } from "./SearchTitle.vue?vue&type=template&id=3cd48591"
import script from "./SearchTitle.vue?vue&type=script&lang=ts"
export * from "./SearchTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports